const settings = {
    connectionString:   /* 'http://localhost:8888' */   'https://api.suelosagradoperu.com',
    googleClientID: "761180188978-prql1hsjsms02gimlb8k13fvha60ecpd.apps.googleusercontent.com",
    googleAPIKEY: "AIzaSyDmAverZKJXVk7-v0VH6EcgZ2pbfaG0vdQ",
    facebookAppID: "692641072422769",
    CulqiPublicKey: "pk_live_edda8b78f2d4e6ea" // pk_live_edda8b78f2d4e6ea pk_test_fe5df5ccd8bcffd2
}
export default settings;